module.exports = __webpack_public_path__ + "media/1.995e2677.mp3";